{
  "formName": "Create Miscellaneous Invoice",
  "formRows": [
    {
      "style": { "gridTemplateColumns": "repeat(12, 1fr)" },
      "formGroups": [
        {
          "style": { "gridColumn": "span 3" },
          "control": {
            "label": "invoiceDate",
            "displayLabel": "Billing Date",
            "disabled": false,
            "placeHolder": "Select",
            "fieldInfo": { "dataType": "date","defaultToCurrentDate": true },
            "permissionConditions": {
              "readOnly": {
                "type": "any",
                "permissionIds": [
                  "FIELD_INVOICES_EDIT_BILLING_DATE"
                ]
              }
            },
            "validators": [{ "type": "required", "message": "Billing Date is required" }]
          }
        },
        {
          "style": { "gridColumn": "span 3" },
          "control": {
            "label": "validTill",
            "displayLabel": "Valid Till",
            "disabled": false,
            "placeHolder": "Select",
            "fieldInfo": { "dataType": "date" },
            "validators": [{ "type": "required", "message": "Valid Till is required" }]
          }
        }
      ]
    },
    {
      "style": { "gridTemplateColumns": "repeat(12, 1fr)" },
      "formGroups": [
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": "cycle",
            "displayLabel": "Cycle",
            "disabled": false,
            "placeHolder": "Select Cycle",
            "fieldInfo": {
              "dataType": "select",
              "options": [
                {
                  "label": "Import",
                  "value": "IMPORT"
                },
                {
                  "label": "Export",
                  "value": "EXPORT"
                },
                {
                  "label": "Empty",
                  "value": "EMPTY"
                },
                {
                  "label": "Bond",
                  "value": "BOND"
                }
              ]
            },
            "validators": [
              {
                "type": "selectRequired",
                "message": "Cycle is required"
              }
            ]
          }
        },
        {
          "style": { "gridColumn": "span 3" },
          "control": {
            "label": "customerId",
            "displayLabel": "Customer",
            "disabled": false,
            "placeHolder": "Select Customer",
            "fieldInfo": {
              "dataType": "picklist",
              "lookupDetails": {
                "apiUrl": "v1/customers/list",
                "filterByKeys": ["NAME_CONTAINS"],
                "additionalFilters": [
                  {
                    "name": "IS_ACTIVE",
                    "alias": "active",
                    "operator": "EQ",
                    "value": ["true"]
                  }
                ],
                "limit": 10,
                "orderBy": { "name": "asc" },
                "filterByKey": "name",
                "bindLabel": "name",
                "bindValue": "id",
                "displayColumns": [
                  { "key": "code", "header": "Code" },
                  { "key": "name", "header": "Name" }
                ]
              }
            },
            "conditions": {
            },
            "validators": [
              {
                "type": "autocompleteRequired",
                "message": "Customer is required"
              }
            ]
          }
        },
        {
          "style": { "gridColumn": "span 3" },
          "control": {
            "label": "billingPartyId",
            "displayLabel": "Billing Party",
            "disabled": false,
            "placeHolder": "Select Billing Party",
            "returnRawValue": false,
            "fieldInfo": {
              "dataType": "picklist",
              "lookupDetails": {
                "apiUrl": "v1/customers/list",
                "filterByKeys": ["NAME_CONTAINS"],
                "additionalFilters": [
                  {
                    "name": "IS_ACTIVE",
                    "alias": "active",
                    "operator": "EQ",
                    "value": [true]
                  }
                ],
                "limit": 10,
                "orderBy": { "name": "asc" },
                "filterByKey": "name",
                "bindLabel": "name",
                "bindValue": "id",
                "displayColumns": [
                  { "key": "code", "header": "Code" },
                  { "key": "name", "header": "Name" }
                ]
              }
            },
            "conditions": {
            },
            "validators": [
              {
                "type": "autocompleteRequired",
                "message": "Customer is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": "billingPartyType",
            "displayLabel": "Billing Party Type",
            "disabled": false,
            "placeHolder": "Select Billing Party Type",
            "fieldInfo": {
              "dataType": "select",
              "options": [
                { "name": "Freight Forwarder", "value": "FREIGHT_FORWARDER" },
                { "name": "Consignee", "value": "CONSIGNEE" },
                { "name": "Line Agent", "value": "LINE_AGENT" },
                { "name": "Line", "value": "LINE" },
                { "name": "CHA", "value": "CHA" },
                { "name": "Transporter", "value": "TRANSPORTER" },
                { "name": "Shipper", "value": "SHIPPER" },
                { "name": "Exporter", "value": "EXPORTER" },
                { "name": "Group Company", "value": "GROUP_COMPANY" },
                { "name": "Broker", "value": "BROKER" },
                { "name": "Other CFS", "value": "OTHER_CFS" }
              ],
              "displayKey": "name",
              "valueKey": "value"
            }
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": "billingAddressId",
            "displayLabel": "Billing Address",
            "disabled": false,
            "placeHolder": "Enter Billing Address",
            "fieldInfo": {
              "dataType": "select",
              "options": []
            },
            "conditions": {
              "disabled": {
                "logic": "AND",
                "rules": [
                  { "field": "customerId", "operator": "EQUALS", "value": null }
                ]
              }
            },
            "validators": [
              {
                "type": "required",
                "message": "Billing Address is required"
              }
            ]
          }
        }
      ]
    },
    {
      "style": { "gridTemplateColumns": "repeat(12, 1fr)" },
      "formGroups": [
        {
          "style": { "gridColumn": "span 3" },
          "control": {
            "label": "chargeGroupId",
            "displayLabel": "Charge Group",
            "disabled": false,
            "placeHolder": "Select Charge Group",
            "fieldInfo": {
              "dataType": "picklist",
              "lookupDetails": {
                "apiUrl": "v1/charge-groups/list",
                "filterByKeys": ["NAME_CONTAINS"],
                "limit": 10,
                "orderBy": { "name": "asc" },
                "filterByKey": "name",
                "bindLabel": "name",
                "bindValue": "id",
                "displayColumns": [
                  { "key": "name", "header": "Name" }
                ]
              }
            },
            "validators": [
              {
                "type": "autocompleteRequired",
                "message": "Charge Group is required"
              }
            ]
          }
        },
        {
          "style": { "gridColumn": "span 3" },
          "control": {
            "label": "paymentTerm",
            "displayLabel": "Payment Term",
            "disabled": false,
            "placeHolder": "Select Payment Term",
            "fieldInfo": {
              "dataType": "select",
              "options": [
                {
                  "label": "Cash/Immediate",
                  "value": "CASH"
                },
                {
                  "label": "Credit",
                  "value": "CREDIT"
                },
                {
                  "label": "PDA",
                  "value": "PDA"
                }
              ]
            },
            "validators": [
              {
                "type": "required",
                "message": "Payment Term is required"
              }
            ]
          }
        },
        {
          "style": {
            "gridColumn": "span 3"
          },
          "control": {
            "label": "payingPartyId",
            "displayLabel": "Paying Party",
            "disabled": false,
            "placeHolder": "Select Paying Party",
            "returnRawValue": false,
            "fieldInfo": {
              "dataType": "picklist",
              "lookupDetails": {
                "apiUrl": "v1/customers/list",
                "filterByKeys": [
                  "NAME_CONTAINS"
                ],
                "additionalFilters": [
                  {
                    "name": "IS_ACTIVE",
                    "alias": "active",
                    "operator": "EQ",
                    "value": [
                      "true"
                    ]
                  }
                ],
                "limit": 10,
                "orderBy": {
                  "name": "asc"
                },
                "bindLabel": "name",
                "bindValue": "id",
                "displayColumns": [
                  {
                    "key": "name",
                    "header": "Name"
                  },
                  {
                    "key": "code",
                    "header": "Code"
                  }
                ]
              }
            },
            "conditions": {
              "visibility": {
                "logic": "AND",
                "rules": [
                  {
                    "field": "paymentTerm",
                    "operator": "EQUALS",
                    "value": "PDA"
                  }
                ]
              }
            },
            "validators": [
              {
                "type": "required",
                "message": "Paying Party is required"
              }
            ]
          }
        }
      ]
    }
  ]
}
